<template>
    <div>
        <div
            v-if="parentView"
            class="menu-top-mobile__header row no-gutters"
            @click="goTo(parentView.id_menu_item_parent)"
        >
            <div class="menu-top-mobile__header-block menu-top-mobile__header-block--first">
                <i class="fal fa-arrow-left" aria-hidden="true"></i>
            </div>
            <div class="menu-top-mobile__header-block menu-top-mobile__header-block--middle">
                <span>{{ parentView.page_title }}</span>
            </div>
            <div class="menu-top-mobile__header-block">
                <a
                    class="menu-top-mobile__offer-button menu-top-mobile__offer-button--shadow"
                    :href="brekzOfferPageLink" v-html="abcTestDiscountButtonHtml"
                    rel="noopener noreferrer"
                ></a>
            </div>
        </div>
        <div
            v-else
            class="menu-top-mobile__header row no-gutters"
        >
            <div class="menu-top-mobile__header-block menu-top-mobile__header-block--first">
                <i class="fal fa-arrow-left" aria-hidden="true"></i>
            </div>
            <div class="menu-top-mobile__header-block menu-top-mobile__header-block--middle">
                <span class="">{{ $t('mobileMenu.makeYourChoice') }}</span>
            </div>
            <div class="menu-top-mobile__header-block">
                <a
                    class="menu-top-mobile__offer-button menu-top-mobile__offer-button--shadow"
                    :href="brekzOfferPageLink" v-html="abcTestDiscountButtonHtml"
                    rel="noopener noreferrer"
                ></a>
            </div>
        </div>

        <ul class="navbar-nav mr-auto menu-top--mobile">
            <template v-for="menuItem in currentView">
                <li
                    :key="menuItem.id_menu_item"
                    class="nav-item menu-top-mobile__item"
                    :class="{
                        'menu-top-mobile__item--thick-bottom-border':
                            menuItem.has_border_bottom
                    }"
                    v-if="menuItem.interaction_link"
                >
                    <a
                        :href="menuItem.interaction_link"
                        :title="menuItem.interaction_title"
                        rel="noopener noreferrer"
                    >
                        {{ menuItem.interaction_title }}
                    </a>
                </li>
                <li
                    :key="menuItem.id_menu_item"
                    class="nav-item menu-top-mobile__item"
                    v-else
                    :class="{
                        'menu-top-mobile__item--thick-bottom-border':
                            menuItem.has_border_bottom
                    }"
                    @click="goTo(menuItem.id_menu_item)"
                >
                    <span>
                        {{ menuItem.interaction_title }}
                    </span>
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </li>
            </template>
            <slot> </slot>
        </ul>
    </div>
</template>

<script>
import { subDays, parse, isBefore } from "date-fns";

export default {
    props: {
        lastModifiedTimestamp: String,
        brekzOfferPageLink: String,
        brekzOfferPageLinkText: String,
    },
    data() {
        return {
            menu: [],
            parentView: null,
            currentView: null,
            showLoadingIndicator: false
        };
    },
    created() {
        this.getMenu();

        window.EventBus.$on("select-mobile-item", value => {
            const mainMenuItem = this.mainMenu.find(item => {
                return item.interaction_value === value;
            });

            if (mainMenuItem) {
                this.goTo(mainMenuItem.id_menu_item);
            }
        });
    },
    mounted() {},
    computed: {
        mainMenu() {
            if (!this.menu) {
                return;
            }

            return this.menu.filter(
                ({ id_menu_item_parent }) => id_menu_item_parent === 0
            );
        },
        abcTestDiscountButtonHtml() {
            return `
                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 46 46">
                    <g id="Group_693" data-name="Group 693" transform="translate(-5102 -8089)">
                        <rect id="Rectangle_749" data-name="Rectangle 749" width="46" height="46" transform="translate(5102 8089)" fill="#e78787"/>
                        <path id="percent" d="M4.019,8.037A4.019,4.019,0,1,0,0,4.019,4.017,4.017,0,0,0,4.019,8.037Zm0-5.741A1.722,1.722,0,1,1,2.3,4.019,1.723,1.723,0,0,1,4.019,2.3Zm8.037,8.037a4.019,4.019,0,1,0,4.019,4.019A4.017,4.017,0,0,0,12.056,10.334Zm0,5.741a1.722,1.722,0,1,1,1.722-1.722A1.723,1.723,0,0,1,12.056,16.074ZM14.076.007,15.21,0a.861.861,0,0,1,.707,1.356L2.777,18a.859.859,0,0,1-.7.366l-1.2,0a.861.861,0,0,1-.707-1.356L13.373.373A.859.859,0,0,1,14.076.007Z" transform="translate(5118.272 8101.913)" fill="#fff"/>
                    </g>
                </svg>
            `;
        }
    },
    methods: {
        getMenu() {
            let endpoint_url = base_url + "module/brekz_topmenu/endpoint";
            if (this.id_category_start) {
                endpoint_url += "?id_category_parent=" + this.id_category_start;
            }

            const storageLastUpdated = parseInt(
                localStorage.getItem("mobile_menu_last_modified")
            );

            if (
                !storageLastUpdated ||
                parseInt(this.lastModifiedTimestamp) > storageLastUpdated
            ) {
                jQuery.ajax({
                    type: "GET",
                    url: endpoint_url,
                    async: true,
                    dataType: "json",
                    success: jsonData => {
                        this.menu = jsonData.items;

                        localStorage.setItem(
                            "mobile_menu_structure",
                            JSON.stringify(jsonData.items)
                        );
                        localStorage.setItem(
                            "mobile_menu_last_modified",
                            jsonData.timestamp_last_modified
                        );
                        localStorage.setItem(
                            "mobile_menu_updated_at",
                            new Date().toJSON()
                        );

                        this.goTo(0);
                    }
                });
            } else {
                this.menu = JSON.parse(
                    localStorage.getItem("mobile_menu_structure")
                );
                this.goTo(0);
            }
        },
        goTo(parent_id) {
            this.currentView = this.menu
                .filter(
                    ({ id_menu_item_parent }) =>
                        id_menu_item_parent == parent_id
                )
                .sort((a, b) => {
                    return a.position - b.position;
                });
            this.parentView = this.menu.filter(
                ({ id_menu_item }) => id_menu_item == parent_id
            )[0];

            this.$nextTick(() => {
                if (window.applyAbTestingToElement) {
                  window.applyAbTestingToElement(this.$el);
                }
            });
        }
    }
};
</script>

<style></style>
